import { render, staticRenderFns } from "./return-package.vue?vue&type=template&id=7fa0f81c&scoped=true"
import script from "./return-package.vue?vue&type=script&lang=ts"
export * from "./return-package.vue?vue&type=script&lang=ts"
import style0 from "./return-package.vue?vue&type=style&index=0&id=7fa0f81c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa0f81c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fa0f81c')) {
      api.createRecord('7fa0f81c', component.options)
    } else {
      api.reload('7fa0f81c', component.options)
    }
    module.hot.accept("./return-package.vue?vue&type=template&id=7fa0f81c&scoped=true", function () {
      api.rerender('7fa0f81c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/return/return-package.vue"
export default component.exports